export default __webpack_public_path__ + "static/media/health-wellness.a326286b.jpg";